import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import styles from './styles/factor.module.scss';
import { useEffect, useRef, useState } from 'react';
import CaseProgressCircle from '@/components/CaseProgressCircle';
import { Storage } from '@/utils/Storage';
import FactorImage from './components/FactorItem/FactorImage';
import FactorModal from './components/Modal/FactorModal';
const Factor = (props) => {
    const [showFactorModal, setShowFactorModal] = useState(false);
    let { navigate } = props;
    const [percent, setPercent] = useState(0);

    const { simulation } = props.store;

    let { curSection, sections, verifyLogin, getPath, currentViewIndex, setCurrentViewIndex } = simulation;
    const goRoleIntroduce = async () => {
        let res = await verifyLogin();
        if (!res) {
            return;
        }
        let path = getPath();
        navigate(`${path}/role-introduce`, { replace: true });
    };
    const onclickArrow = () => {
        if (currentViewIndex === sections.length - 1) {
            goRoleIntroduce();
            return;
        }
    };

    useEffect(() => {
        if (currentViewIndex === sections.length - 1) {
            return;
        }
        //如果当前索引小于目标索引，说明用户是在往前滑动，需要更新当前索引
        //如果当前索引大于等于目标索引，说明用户是在往后滑动，不需要更新当前索引
        if (currentViewIndex < curSection?.originalIndex) {
            setCurrentViewIndex(curSection?.originalIndex);
        }
    }, [curSection]);
    const handlePercent = () => {
        setPercent(((currentViewIndex + 1) / sections.length) * 100);
    };
    useEffect(() => {
        handlePercent();
    }, [currentViewIndex]);
    useEffect(() => {
        let backGuide = Storage.get(simulation.factorStorageName);
        if (!backGuide) {
            setShowFactorModal(true);
        }
    }, []);
    return (
        <>
            <div className={styles['factor-box']}>
                <FactorModal setShowFactorModal={setShowFactorModal} visible={showFactorModal}></FactorModal>
                <div className={styles.container}>
                    {/* 文本描述 */}
                    <div className={styles.textDescription}>{curSection.content}</div>

                    {/* 主图片区域 */}
                    <FactorImage></FactorImage>
                    {/* 箭头图标 */}
                    <div className={styles.arrowContainer}>
                        <CaseProgressCircle onclickArrow={onclickArrow} percent={percent} />
                    </div>
                </div>
            </div>
        </>
    );
};
export default withRouter(inject('store')(observer(Factor)));
